function btgQuoteDetails(data) {
  const quantity = Number(data.quantity);
  if (!Number.isSafeInteger(quantity) || quantity < 25) return null;
  return [
    'Product: ' + (data.product || ''),
    'SKU: ' + (data.sku || ''),
    'Product page: ' + (data.url || ''),
    'Requested order quantity: ' + quantity,
    data.requirements && 'Requirements: ' + data.requirements.trim()
  ].filter(Boolean).join('\n');
}

if (!customElements.get('btg-product-enquiry')) {
  customElements.define('btg-product-enquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.dataset.ready = 'true';
      form.addEventListener('submit', (event) => {
        const details = btgQuoteDetails({
          product: this.dataset.product,
          sku: this.dataset.sku,
          url: this.dataset.url,
          quantity: form.querySelector('[data-quote-quantity]').value,
          requirements: form.querySelector('[data-quote-requirements]').value
        });
        if (!details) {
          event.preventDefault();
          form.querySelector('[data-quote-quantity]').reportValidity();
          return;
        }
        event.preventDefault();
        window.location.assign(form.action + '?q10_textarea9=' + encodeURIComponent(details));
      });
    }
  });
}
